// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

    /**************************************************************************
     * Color Palette
     *************************************************************************/


    --primary-color-lightest: #FAFBFC; /* Hue: 204, Saturation: 1, Brightness: 99  -- Off the pattern for a more grey hue. */
    --primary-color-light: #e6ecf2;
    --primary-color-main: #398fe5;
    --primary-color-main-highlight: #67a6e5;
    --primary-color-dark: #44484c;
    --primary-color-darkest: #161819; 

    --secondary-color-lightest: #FFFCFA; 
    --secondary-color-light: #F2E5DA;
    --secondary-color-main: #FB994C;
    --secondary-color-main-highlight: #fab37d;
    --secondary-color-dark: #4d4845;
    --secondary-color-darkest: #1a1919;

    --success-color-lightest: #FAFFFA;
    --success-color-light: #DBF2DA;
    --success-color-main: #45CB3E;
    --success-color-main-highlight: #6dcc68;
    --success-color-dark: #454d45;
    --success-color-darkest: #191a19;

    --danger-color-lightest: #FFFAFA;
    --danger-color-light: #F2DADB;
    --danger-color-main: #bc0309;
    --danger-color-main-highlight: #d3565a; 
    --danger-color-dark: #4d4545;
    --danger-color-darkest: #1a1919;

    /**************************************************************************
     * End Color Palette
     *************************************************************************/

    /**
     * Highlight colors
     *
     * Used to highlight menu selections.
     **/
    --primary-highlight-color: var(--primary-color-main);
    --success-highlight-color: var(--success-color-main);
    --warn-highlight-color: var(--danger-color-dark);

    /** Header colors **/
    --header-background-color: white;
    --header-border-color: var(--primary-color-light);
    --header-text-color: var(--primary-color-darkest);
    --header-text-highlight-color: var(--primary-color-dark);
    --header-spacer-color: var(--primary-color-light);

    /** Footer colors **/
    --footer-background-color: var(--primary-color-lightest);
    --footer-border-color: var(--primary-color-light);
    --footer-text-color: var(--primary-color-darkest);

    /** Header menu colors **/ 
    --header-menu-background-color: var(--primary-color-lightest);
    --header-menu-border-color: var(--primary-color-light);
    --header-menu-spacer-color: var(--primary-color-light);
    --header-menu-text-color: var(--primary-color-darkest);
    --header-menu-text-highlight-color: var(--primary-color-dark);
    --header-menu-background-highlight-color: var(--primary-color-main);


    /** Page Header **/
    --page-header-background-color: var(--primary-color-lightest);

    /** Page **/
    --page-background-color: var(--primary-color-lightest);
    --page-text-color: var(--primary-color-darkest);
    --page-border-color: none;

    /** Page Tab Bar **/
    --tab-bar-background-color: var(--primary-color-lightest);
    --tab-bar-border-color: var(--primary-color-light);
    --tab-bar-text-color: var(--primary-color-darkest);
    --tab-bar-icon-color: var(--primary-color-darkest);

    /** Main **/
    --main-background-color: var(--primary-color-lightest);
    --main-border-color: var(--primary-color-light);
    --main-text-color: var(--primary-color-darkest);
    --main-icon-color: var(--primary-color-light);
    --main-icon-highlight-color: var(--primary-color-main);

    --icon-color: var(--primary-color-darkest);

    --floating-menu-border-color: var(--primary-color-light);
    --floating-menu-icon-color: var(--primary-color-light);

    --card-header-background-color: var(--primary-color-lightest);
    --card-border-color: var(--primary-color-light);
    --dots-menu-color: var(--primary-color-light);

    --input-background-color: var(--primary-color-lightest);
    --input-focus-background-color: white;
    --input-border-color: var(--primary-color-light);
    --input-highlight-color: var(--primary-color-main);

    --link-color: var(--primary-color-main);
    --link-highlight-color: var(--primary-color-main-highlight);

    --button-color: var(--primary-color-lightest);
    --button-border-color: var(--primary-color-light);

    --button-primary-color: var(--primary-color-main);
    --button-highlight-color: var(--primary-color-main-highlight);
    --button-warn-color: var(--danger-color-main);

    --tag-background-color: white;
    --tag-border-color: var(--primary-color-light);
}

html {
    height: 100%;
}

body {
    padding: 0;
    margin: 0;
    height: 100%;

    font-family: Roboto, Arial, sans-serif; 
    /*font-family: "Atkinson Hyperlegible", Roboto, Arial, sans-serif;*/
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    background-color: var(--main-background-color);

    overflow-y: scroll;
}

a:link, a:active, a:visited {
    text-decoration: none;
    color: var(--link-color); 
}

a:hover {
    text-decoration: none;
    color: var(--link-highlight-color); 
}

input[type="text"], input[type="password"], textarea {
    box-sizing: border-box;
    padding: 7px;
    border: thin solid var(--input-border-color);
    border-radius: 7px;
    font-family: Roboto, Arial, sans-serif; 
    font-size: 16px;
    color: var(--main-text-color);
}
input::placeholder, textarea::placeholder {
    font-family: Roboto, Arial, sans-serif; 
    font-size: 14px;
}

input[type="submit"] {
    all: unset;

    display: inline-block;
    border-radius: 5px;
    padding: 5px 15px;
    margin: 5px;
    cursor: pointer;

    background-color: var(--primary-color-main);
    border: thin solid var(--primary-color-main);
    color: white;
}
input[type="submit"]:hover {
    filter: opacity(80%);
}

svg.icon { 
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-bottom: -0.2em;
}

#root {
    width: 100%;
    display: grid;
    grid-template-rows: 1fr;
}

.maintenance-mode {
    width: 800px;
    margin: 100px auto;
    text-align: center;
}

@media (width >= 700px) {
    #root {
        height: 100vh;
    }

}
@media (width < 700px) {

}

`, "",{"version":3,"sources":["webpack://./client/app.css"],"names":[],"mappings":"AAAA;;IAEI;;8EAE0E;;;IAG1E,iCAAiC,EAAE,qFAAqF;IACxH,8BAA8B;IAC9B,6BAA6B;IAC7B,uCAAuC;IACvC,6BAA6B;IAC7B,gCAAgC;;IAEhC,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,yCAAyC;IACzC,+BAA+B;IAC/B,kCAAkC;;IAElC,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,uCAAuC;IACvC,6BAA6B;IAC7B,gCAAgC;;IAEhC,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,sCAAsC;IACtC,4BAA4B;IAC5B,+BAA+B;;IAE/B;;8EAE0E;;IAE1E;;;;OAIG;IACH,oDAAoD;IACpD,oDAAoD;IACpD,gDAAgD;;IAEhD,oBAAoB;IACpB,gCAAgC;IAChC,iDAAiD;IACjD,iDAAiD;IACjD,wDAAwD;IACxD,iDAAiD;;IAEjD,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;IACjD,iDAAiD;;IAEjD,yBAAyB;IACzB,6DAA6D;IAC7D,sDAAsD;IACtD,sDAAsD;IACtD,sDAAsD;IACtD,6DAA6D;IAC7D,mEAAmE;;;IAGnE,kBAAkB;IAClB,6DAA6D;;IAE7D,WAAW;IACX,sDAAsD;IACtD,+CAA+C;IAC/C,yBAAyB;;IAEzB,mBAAmB;IACnB,yDAAyD;IACzD,kDAAkD;IAClD,kDAAkD;IAClD,kDAAkD;;IAElD,WAAW;IACX,sDAAsD;IACtD,+CAA+C;IAC/C,+CAA+C;IAC/C,6CAA6C;IAC7C,sDAAsD;;IAEtD,0CAA0C;;IAE1C,wDAAwD;IACxD,sDAAsD;;IAEtD,6DAA6D;IAC7D,+CAA+C;IAC/C,6CAA6C;;IAE7C,uDAAuD;IACvD,qCAAqC;IACrC,gDAAgD;IAChD,kDAAkD;;IAElD,uCAAuC;IACvC,2DAA2D;;IAE3D,6CAA6C;IAC7C,iDAAiD;;IAEjD,iDAAiD;IACjD,6DAA6D;IAC7D,6CAA6C;;IAE7C,6BAA6B;IAC7B,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;;IAEZ,sCAAsC;IACtC,mEAAmE;IACnE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;;IAE9C,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,4CAA4C;IAC5C,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,UAAU;;IAEV,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;;IAEf,2CAA2C;IAC3C,4CAA4C;IAC5C,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;;AAEJ;AACA;;AAEA","sourcesContent":[":root {\n\n    /**************************************************************************\n     * Color Palette\n     *************************************************************************/\n\n\n    --primary-color-lightest: #FAFBFC; /* Hue: 204, Saturation: 1, Brightness: 99  -- Off the pattern for a more grey hue. */\n    --primary-color-light: #e6ecf2;\n    --primary-color-main: #398fe5;\n    --primary-color-main-highlight: #67a6e5;\n    --primary-color-dark: #44484c;\n    --primary-color-darkest: #161819; \n\n    --secondary-color-lightest: #FFFCFA; \n    --secondary-color-light: #F2E5DA;\n    --secondary-color-main: #FB994C;\n    --secondary-color-main-highlight: #fab37d;\n    --secondary-color-dark: #4d4845;\n    --secondary-color-darkest: #1a1919;\n\n    --success-color-lightest: #FAFFFA;\n    --success-color-light: #DBF2DA;\n    --success-color-main: #45CB3E;\n    --success-color-main-highlight: #6dcc68;\n    --success-color-dark: #454d45;\n    --success-color-darkest: #191a19;\n\n    --danger-color-lightest: #FFFAFA;\n    --danger-color-light: #F2DADB;\n    --danger-color-main: #bc0309;\n    --danger-color-main-highlight: #d3565a; \n    --danger-color-dark: #4d4545;\n    --danger-color-darkest: #1a1919;\n\n    /**************************************************************************\n     * End Color Palette\n     *************************************************************************/\n\n    /**\n     * Highlight colors\n     *\n     * Used to highlight menu selections.\n     **/\n    --primary-highlight-color: var(--primary-color-main);\n    --success-highlight-color: var(--success-color-main);\n    --warn-highlight-color: var(--danger-color-dark);\n\n    /** Header colors **/\n    --header-background-color: white;\n    --header-border-color: var(--primary-color-light);\n    --header-text-color: var(--primary-color-darkest);\n    --header-text-highlight-color: var(--primary-color-dark);\n    --header-spacer-color: var(--primary-color-light);\n\n    /** Footer colors **/\n    --footer-background-color: var(--primary-color-lightest);\n    --footer-border-color: var(--primary-color-light);\n    --footer-text-color: var(--primary-color-darkest);\n\n    /** Header menu colors **/ \n    --header-menu-background-color: var(--primary-color-lightest);\n    --header-menu-border-color: var(--primary-color-light);\n    --header-menu-spacer-color: var(--primary-color-light);\n    --header-menu-text-color: var(--primary-color-darkest);\n    --header-menu-text-highlight-color: var(--primary-color-dark);\n    --header-menu-background-highlight-color: var(--primary-color-main);\n\n\n    /** Page Header **/\n    --page-header-background-color: var(--primary-color-lightest);\n\n    /** Page **/\n    --page-background-color: var(--primary-color-lightest);\n    --page-text-color: var(--primary-color-darkest);\n    --page-border-color: none;\n\n    /** Page Tab Bar **/\n    --tab-bar-background-color: var(--primary-color-lightest);\n    --tab-bar-border-color: var(--primary-color-light);\n    --tab-bar-text-color: var(--primary-color-darkest);\n    --tab-bar-icon-color: var(--primary-color-darkest);\n\n    /** Main **/\n    --main-background-color: var(--primary-color-lightest);\n    --main-border-color: var(--primary-color-light);\n    --main-text-color: var(--primary-color-darkest);\n    --main-icon-color: var(--primary-color-light);\n    --main-icon-highlight-color: var(--primary-color-main);\n\n    --icon-color: var(--primary-color-darkest);\n\n    --floating-menu-border-color: var(--primary-color-light);\n    --floating-menu-icon-color: var(--primary-color-light);\n\n    --card-header-background-color: var(--primary-color-lightest);\n    --card-border-color: var(--primary-color-light);\n    --dots-menu-color: var(--primary-color-light);\n\n    --input-background-color: var(--primary-color-lightest);\n    --input-focus-background-color: white;\n    --input-border-color: var(--primary-color-light);\n    --input-highlight-color: var(--primary-color-main);\n\n    --link-color: var(--primary-color-main);\n    --link-highlight-color: var(--primary-color-main-highlight);\n\n    --button-color: var(--primary-color-lightest);\n    --button-border-color: var(--primary-color-light);\n\n    --button-primary-color: var(--primary-color-main);\n    --button-highlight-color: var(--primary-color-main-highlight);\n    --button-warn-color: var(--danger-color-main);\n\n    --tag-background-color: white;\n    --tag-border-color: var(--primary-color-light);\n}\n\nhtml {\n    height: 100%;\n}\n\nbody {\n    padding: 0;\n    margin: 0;\n    height: 100%;\n\n    font-family: Roboto, Arial, sans-serif; \n    /*font-family: \"Atkinson Hyperlegible\", Roboto, Arial, sans-serif;*/\n    font-size: 14px;\n    font-weight: 400;\n    font-style: normal;\n    background-color: var(--main-background-color);\n\n    overflow-y: scroll;\n}\n\na:link, a:active, a:visited {\n    text-decoration: none;\n    color: var(--link-color); \n}\n\na:hover {\n    text-decoration: none;\n    color: var(--link-highlight-color); \n}\n\ninput[type=\"text\"], input[type=\"password\"], textarea {\n    box-sizing: border-box;\n    padding: 7px;\n    border: thin solid var(--input-border-color);\n    border-radius: 7px;\n    font-family: Roboto, Arial, sans-serif; \n    font-size: 16px;\n    color: var(--main-text-color);\n}\ninput::placeholder, textarea::placeholder {\n    font-family: Roboto, Arial, sans-serif; \n    font-size: 14px;\n}\n\ninput[type=\"submit\"] {\n    all: unset;\n\n    display: inline-block;\n    border-radius: 5px;\n    padding: 5px 15px;\n    margin: 5px;\n    cursor: pointer;\n\n    background-color: var(--primary-color-main);\n    border: thin solid var(--primary-color-main);\n    color: white;\n}\ninput[type=\"submit\"]:hover {\n    filter: opacity(80%);\n}\n\nsvg.icon { \n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin-bottom: -0.2em;\n}\n\n#root {\n    width: 100%;\n    display: grid;\n    grid-template-rows: 1fr;\n}\n\n.maintenance-mode {\n    width: 800px;\n    margin: 100px auto;\n    text-align: center;\n}\n\n@media (width >= 700px) {\n    #root {\n        height: 100vh;\n    }\n\n}\n@media (width < 700px) {\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
